import React, { useState, useEffect } from 'react';
import domain from '../../../../reusecomponent/domain';
import { getToken } from '../../../function/token';

export default function StartBotModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    keywords: [],
    matchingType: 'exact',
    title: '',
    // Commented out other fields - keeping only essential ones
    // addLabels: [],
    // removeLabels: [],
    // subscribeSequence: '',
    // unsubscribeSequence: '',
    // customField: '',
    // assignToGroup: '',
    // assignToUser: '',
    // webhookUrl: ''
  });
  const [newKeyword, setNewKeyword] = useState('');
  // Commented out other state variables
  // const [newAddLabel, setNewAddLabel] = useState('');
  // const [newRemoveLabel, setNewRemoveLabel] = useState('');
  // const [sequences, setSequences] = useState([]);
  // const [customFields, setCustomFields] = useState([]);
  // const [teamRoles, setTeamRoles] = useState([]);
  // const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    if (open && node) {
      setFormData({
        keywords: node.data.keywords || [],
        matchingType: node.data.matchingType || 'exact',
        title: node.data.title || '',
        // Commented out other fields
        // addLabels: node.data.addLabels || [],
        // removeLabels: node.data.removeLabels || [],
        // subscribeSequence: node.data.subscribeSequence || '',
        // unsubscribeSequence: node.data.unsubscribeSequence || '',
        // customField: node.data.customField || '',
        // assignToGroup: node.data.assignToGroup || '',
        // assignToUser: node.data.assignToUser || '',
        // webhookUrl: node.data.webhookUrl || ''
      });
      setNewKeyword(''); // Reset new keyword input when modal opens
    }
  }, [open, node]);

  // Commented out loadData useEffect and function
  // useEffect(() => {
  //   if (open) {
  //     loadData();
  //   }
  // }, [open]);

  // const loadData = async () => {
  //   // Load sequences, custom fields, team roles, and team members
  //   // This would typically come from your API
  //   setSequences([
  //     { id: '1', name: 'Welcome Sequence' },
  //     { id: '2', name: 'Onboarding Sequence' },
  //     { id: '3', name: 'Support Sequence' }
  //   ]);
  //   setCustomFields([
  //     { id: '1', name: 'Customer Type' },
  //     { id: '2', name: 'Lead Source' },
  //     { id: '3', name: 'Priority Level' }
  //   ]);
  //   setTeamRoles([
  //     { id: '1', name: 'Sales Team' },
  //     { id: '2', name: 'Support Team' },
  //     { id: '3', name: 'Admin Team' }
  //   ]);
  //   setTeamMembers([
  //     { id: '1', name: 'John Doe' },
  //     { id: '2', name: 'Jane Smith' },
  //     { id: '3', name: 'Mike Johnson' }
  //   ]);
  // };

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  const handleCancel = () => {
    // Reset form data to original values when canceling
    if (node) {
      setFormData({
        keywords: node.data.keywords || [],
        matchingType: node.data.matchingType || 'exact',
        title: node.data.title || '',
      });
    }
    onClose();
  };

  const addKeyword = () => {
    if (newKeyword.trim() && !formData.keywords.includes(newKeyword.trim())) {
      setFormData(prev => ({
        ...prev,
        keywords: [...prev.keywords, newKeyword.trim()]
      }));
      setNewKeyword('');
    }
  };

  const removeKeyword = (index) => {
    setFormData(prev => ({
      ...prev,
      keywords: prev.keywords.filter((_, i) => i !== index)
    }));
  };

  // Prevent modal from closing when clicking inside the content area
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  // Commented out label management functions
  // const addLabel = (type) => {
  //   const value = type === 'add' ? newAddLabel : newRemoveLabel;
  //   if (value.trim()) {
  //     setFormData(prev => ({
  //       ...prev,
  //       [type === 'add' ? 'addLabels' : 'removeLabels']: [...prev[type === 'add' ? 'addLabels' : 'removeLabels'], value.trim()]
  //     }));
  //     if (type === 'add') setNewAddLabel('');
  //     else setNewRemoveLabel('');
  //   }
  // };

  // const removeLabel = (type, index) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     [type === 'add' ? 'addLabels' : 'removeLabels']: prev[type === 'add' ? 'addLabels' : 'removeLabels'].filter((_, i) => i !== index)
  //   }));
  // };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '600px',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none'
  };

  // Commented out unused styles
  // const selectStyle = {
  //   width: '100%',
  //   border: '1px solid #d1d5db',
  //   borderRadius: '4px',
  //   padding: '8px 12px',
  //   fontSize: '14px',
  //   marginBottom: '12px',
  //   outline: 'none',
  //   background: '#ffffff'
  // };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    marginLeft: '8px'
  };

  const matchingTypeButtonStyle = (isSelected) => ({
    background: isSelected ? '#007bff' : '#ffffff',
    color: isSelected ? '#ffffff' : '#495057',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px',
    transition: 'all 0.2s ease'
  });

  const tagStyle = {
    background: '#e9ecef',
    color: '#495057',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '12px',
    marginRight: '6px',
    marginBottom: '6px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  };

  return (
    <div style={modalStyle} onClick={handleCancel}>
      <div style={contentStyle} onClick={handleContentClick}>
        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure Reference
          </h2>
        </div>

        {/* Keywords for Bot Trigger */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Write down the keywords for which the bot will be triggered
          </label>
          <input
            type="text"
            value={newKeyword}
            onChange={e => setNewKeyword(e.target.value)}
            placeholder="Hello, Hi, Start"
            style={inputStyle}
            onKeyPress={e => e.key === 'Enter' && addKeyword()}
          />
          <button onClick={addKeyword} style={buttonStyle}>Add</button>
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '8px' }}>
            {formData.keywords.map((keyword, index) => (
              <span key={index} style={tagStyle}>
                {keyword}
                <button
                  onClick={() => removeKeyword(index)}
                  style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '14px' }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

        {/* Matching Type */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Send reply based on your matching type
          </label>
          <div>
            <button
              style={matchingTypeButtonStyle(formData.matchingType === 'exact')}
              onClick={() => setFormData(prev => ({ ...prev, matchingType: 'exact' }))}
            >
              Exact keyword match
            </button>
            <button
              style={matchingTypeButtonStyle(formData.matchingType === 'string')}
              onClick={() => setFormData(prev => ({ ...prev, matchingType: 'string' }))}
            >
              String match
            </button>
          </div>
        </div>

        {/* Title */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Title
          </label>
          <input
            type="text"
            value={formData.title}
            onChange={e => setFormData(prev => ({ ...prev, title: e.target.value }))}
            placeholder="Enter title"
            style={inputStyle}
          />
        </div>

        {/* Commented out Labels section */}
        {/* <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Add Label(s)
              </label>
              <div style={{ display: 'flex' }}>
                <input
                  type="text"
                  value={newAddLabel}
                  onChange={e => setNewAddLabel(e.target.value)}
                  placeholder="Enter label"
                  style={{ ...inputStyle, marginBottom: 0 }}
                  onKeyPress={e => e.key === 'Enter' && addLabel('add')}
                />
                <button onClick={() => addLabel('add')} style={buttonStyle}>+ New</button>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '8px' }}>
                {formData.addLabels.map((label, index) => (
                  <span key={index} style={tagStyle}>
                    {label}
                    <button
                      onClick={() => removeLabel('add', index)}
                      style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '14px' }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Remove Label(s)
              </label>
              <div style={{ display: 'flex' }}>
                <input
                  type="text"
                  value={newRemoveLabel}
                  onChange={e => setNewRemoveLabel(e.target.value)}
                  placeholder="Enter label"
                  style={{ ...inputStyle, marginBottom: 0 }}
                  onKeyPress={e => e.key === 'Enter' && addLabel('remove')}
                />
                <button onClick={() => addLabel('remove')} style={buttonStyle}>+ New</button>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '8px' }}>
                {formData.removeLabels.map((label, index) => (
                  <span key={index} style={tagStyle}>
                    {label}
                    <button
                      onClick={() => removeLabel('remove', index)}
                      style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '14px' }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div> */}

        {/* Commented out Sequence Management section */}
        {/* <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Subscribe to Sequence
              </label>
              <select
                value={formData.subscribeSequence}
                onChange={e => setFormData(prev => ({ ...prev, subscribeSequence: e.target.value }))}
                style={selectStyle}
              >
                <option value="">Select a Sequence</option>
                {sequences.map(seq => (
                  <option key={seq.id} value={seq.id}>{seq.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Unsubscribe from Sequence
              </label>
              <select
                value={formData.unsubscribeSequence}
                onChange={e => setFormData(prev => ({ ...prev, unsubscribeSequence: e.target.value }))}
                style={selectStyle}
              >
                <option value="">Select a Sequence</option>
                {sequences.map(seq => (
                  <option key={seq.id} value={seq.id}>{seq.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div> */}

        {/* Commented out Custom Field section */}
        {/* <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Save to custom field
          </label>
          <div style={{ display: 'flex' }}>
            <select
              value={formData.customField}
              onChange={e => setFormData(prev => ({ ...prev, customField: e.target.value }))}
              style={{ ...selectStyle, marginBottom: 0, flex: 1 }}
            >
              <option value="">Select</option>
              {customFields.map(field => (
                <option key={field.id} value={field.id}>{field.name}</option>
              ))}
            </select>
            <button style={buttonStyle}>+ Add new</button>
          </div>
        </div> */}

        {/* Commented out Conversation Assignment section */}
        {/* <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Assign Conversation to a group
              </label>
              <select
                value={formData.assignToGroup}
                onChange={e => setFormData(prev => ({ ...prev, assignToGroup: e.target.value }))}
                style={selectStyle}
              >
                <option value="">Select Team Role</option>
                {teamRoles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
                Assign conversation to a user
              </label>
              <select
                value={formData.assignToUser}
                onChange={e => setFormData(prev => ({ ...prev, assignToUser: e.target.value }))}
                style={selectStyle}
              >
                <option value="">Select Team Member</option>
                {teamMembers.map(member => (
                  <option key={member.id} value={member.id}>{member.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div> */}

        {/* Commented out Webhook URL section */}
        {/* <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Send data to Webhook URL
          </label>
          <input
            type="url"
            value={formData.webhookUrl}
            onChange={e => setFormData(prev => ({ ...prev, webhookUrl: e.target.value }))}
            placeholder="https://your-webhook-url.com"
            style={inputStyle}
          />
        </div> */}

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button
            onClick={handleCancel}
            style={{ 
              background: '#6c757d', 
              color: '#ffffff', 
              border: 'none', 
              borderRadius: '4px', 
              padding: '8px 16px', 
              fontSize: '14px', 
              cursor: 'pointer' 
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            style={{ 
              background: '#007bff', 
              color: '#ffffff', 
              border: 'none', 
              borderRadius: '4px', 
              padding: '8px 16px', 
              fontSize: '14px', 
              cursor: 'pointer' 
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
} 